var style = {"z-loader-svg":"z-loader-svg","pp-anim-loader-paw":"pp-anim-loader-paw","z-loader-svg--white":"z-loader-svg--white"};

export { style as default };
//# sourceMappingURL=LoaderSvg.module.scss.js.map
